module.exports = __webpack_public_path__ + "static/media/comment-alt-dots.0259ef96.svg";